import { lazy } from 'react';

import { loadTranslations } from './translationLoader';

interface LazyLoadProps {
  component?: string;
  componentPath: string;
  folder: string;
  additionalTranslationFolders?: Array<string>;
  basePath?: string;
}

export function lazyLoad({
  folder,
  componentPath,
  component,
  additionalTranslationFolders,
  basePath = 'features',
}: LazyLoadProps) {
  const language = 'es';
  const translationFolders = [folder].concat(additionalTranslationFolders || []);

  return lazy(async () => {
    await loadTranslations(translationFolders, language);
    const path = `${folder}/${componentPath}`;
    const module = await import(`../${basePath}/${path}.tsx`);
    return {
      default: component ? module[component] : module.default,
    };
  });
}
